import {
  EQUIPOS_VENTA,
  esEquipoVenta,
  puedeTenerEquipo,
  type EquipoVenta,
} from '@lib/catalogs/equipos-venta';
import type { UserRole } from '@lib/types';

/**
 * Selector del equipo de ventas de un usuario (VEN-516). Es la celda de la
 * columna Equipo en Usuarios: cambiar la opción guarda en el acto, como el
 * resto de las acciones por fila. "Sin equipo" manda `null`.
 */
export function EquipoSelect({
  nombre,
  rol,
  value,
  disabled,
  onChange,
}: {
  nombre: string;
  rol: UserRole;
  value: EquipoVenta | null | undefined;
  disabled?: boolean;
  onChange: (equipo: EquipoVenta | null) => void;
}) {
  if (!puedeTenerEquipo(rol)) return <span className="text-element-mid">—</span>;
  return (
    <select
      className="input"
      style={{ maxWidth: 160 }}
      aria-label={`Equipo de ${nombre}`}
      value={value ?? ''}
      disabled={disabled}
      onChange={(e) => {
        const v = e.target.value;
        onChange(esEquipoVenta(v) ? v : null);
      }}
    >
      <option value="">Sin equipo</option>
      {EQUIPOS_VENTA.map((eq) => (
        <option key={eq.key} value={eq.key}>
          {eq.label}
        </option>
      ))}
    </select>
  );
}
